import React from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import Box from '@material-ui/core/Box'
import { makeStyles } from '@material-ui/core/styles'
import { BENCHMARK_COLORS, getBenchmarkScaleFillColor } from './benchmark-chips'
import { getBenchmarkStatusTier, getDetailScalePercent } from './utils'

const COACH_MARKER_COLOR = '#00234B'

const useStyles = makeStyles(() => ({
  track: {
    position: 'relative',
    height: 6,
    borderRadius: 3,
    backgroundColor: BENCHMARK_COLORS.neutral.track,
  },
  fill: {
    position: 'absolute',
    top: 0,
    left: 0,
    height: '100%',
    borderRadius: 3,
  },
  coachMarker: {
    position: 'absolute',
    top: '50%',
    width: 10,
    height: 10,
    borderRadius: '50%',
    backgroundColor: COACH_MARKER_COLOR,
    border: '2px solid #FFFFFF',
    transform: 'translate(-50%, -50%)',
    zIndex: 2,
  },
  tick: {
    position: 'absolute',
    top: -3,
    bottom: -3,
    width: 1,
    backgroundColor: BENCHMARK_COLORS.neutral.marker,
    transform: 'translateX(-50%)',
    zIndex: 1,
  },
}))

export const BenchmarkScaleTick = ({ percent }) => {
  const classes = useStyles()

  return <Box className={classes.tick} style={{ left: `${percent}%` }} />
}

BenchmarkScaleTick.propTypes = {
  percent: PropTypes.number.isRequired,
}

const BenchmarkScaleTrack = ({ metric, className, children }) => {
  const classes = useStyles()
  const coachPercent = getDetailScalePercent(metric.coachValue, metric)

  return (
    <Box className={clsx(classes.track, className)} aria-hidden>
      <Box
        className={classes.fill}
        data-testid="benchmark-scale-fill"
        style={{
          width: `${coachPercent}%`,
          backgroundColor: getBenchmarkScaleFillColor(
            getBenchmarkStatusTier(metric),
          ),
        }}
      />
      <Box
        className={classes.coachMarker}
        data-testid="benchmark-scale-coach-marker"
        style={{ left: `${coachPercent}%` }}
      />
      {children}
    </Box>
  )
}

BenchmarkScaleTrack.propTypes = {
  metric: PropTypes.shape({
    coachValue: PropTypes.number.isRequired,
    medianValue: PropTypes.number.isRequired,
    higherIsBetter: PropTypes.bool.isRequired,
    gettingStartedValue: PropTypes.number.isRequired,
    top10Value: PropTypes.number.isRequired,
  }).isRequired,
  className: PropTypes.string,
  children: PropTypes.node,
}

export default BenchmarkScaleTrack
